import { onRequest, RequestMethod } from "../common/axios/axios"
import { getApiUrl } from "../common/axios/getApiUrl"

export class TermsRepository {
    // 약관 목록 — service 별 활성 약관 (DOKOPANG / DOKOCREW 등)
    static onGetTermsList = (locale: string, serviceId: string, searchTag?: string) => {
        const query: { [key: string]: string } = searchTag ? { locale, searchTag } : { locale };

        return onRequest({
            url: getApiUrl('terms-list') + serviceId,
            method: RequestMethod.GET,
            query
        })
    }

    // 약관 상세
    static onGetTermsDetail = (termsId: string | number) => {
        return onRequest({
            url: getApiUrl('terms-detail') + termsId,
            method: RequestMethod.GET
        })
    }
}
